import React, { useEffect } from "react";
import { DateRangePicker } from "@/components/ui/date-range-picker";
import { CalendarIcon } from "lucide-react";
import { differenceInDays } from "date-fns";
interface FishingDateSelectionProps {
  fishingStart: Date | undefined;
  setFishingStart: (date: Date | undefined) => void;
  fishingEnd: Date | undefined;
  setFishingEnd: (date: Date | undefined) => void;
  days: number;
  permitType: string;
  setPermitType: (type: string) => void;
}
export const FishingDateSelection: React.FC<FishingDateSelectionProps> = ({
  fishingStart,
  setFishingStart,
  fishingEnd,
  setFishingEnd,
  days,
  permitType,
  setPermitType
}) => {
  // Calculate days between dates (including both start and end dates)
  const calculateDays = (startDate?: Date, endDate?: Date) => {
    if (!startDate || !endDate) return 0;

    // Normalize dates for consistent calculation
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);

    // Add 1 because we want to include both the start and end date
    const calculatedDays = differenceInDays(end, start) + 1;
    console.log(`FishingDateSelection - NORMALIZED Date range: ${start.toDateString()} to ${end.toDateString()}, Days: ${calculatedDays} (inclusive)`);
    return calculatedDays;
  };

  // Log days calculation for debugging
  useEffect(() => {
    if (fishingStart && fishingEnd) {
      const calculatedDays = calculateDays(fishingStart, fishingEnd);
      console.log(`FishingDateSelection - Calculated days: ${calculatedDays}`);
    }
  }, [fishingStart, fishingEnd]);

  return <div className="mb-8">
      <h3 className="font-semibold text-lg text-tribal-secondary mb-4">Fishing Trip Dates</h3>
      <p className="text-sm text-tribal-neutral mb-3 font-normal">Each fishing day runs 2 hours before sunrise to 1 hour after sunset.</p>
      <DateRangePicker startDate={fishingStart} endDate={fishingEnd} setStartDate={setFishingStart} setEndDate={setFishingEnd} startLabel="First Day on Water" endLabel="Last Day on Water" placeholder="Select your fishing trip dates" displayUnit="days" />
      <div className="mt-2 text-sm text-tribal-neutral flex items-center">
        <CalendarIcon className="h-4 w-4 mr-2 text-tribal-primary" />
        Total duration: <span className="font-medium text-tribal-secondary ml-1">{days} day{days !== 1 ? 's' : ''}</span>
        {permitType.startsWith("daily") && days >= 6 && <span className="ml-2 text-muted-foreground text-xs">
            (Tip: An annual permit may save you money)
          </span>}
      </div>
    </div>;
};